module.exports = __webpack_public_path__ + "static/moby-dick-6dd406f88eacc2e70b6afac45ed5e99f.jpg";